module.exports = __webpack_public_path__ + "img/login-v3.a2b288ff.svg";